import { useEffect, useState } from 'react'

interface RoundInfoProps {
  pool: string
  participants: number
  endTime: number
  state: number | string
}

export function RoundInfo({ pool, endTime, state }: RoundInfoProps) {
  const [timeLeft, setTimeLeft] = useState('')

  useEffect(() => {
    const updateTimer = () => {
      if (!endTime || endTime === 0) {
        setTimeLeft('—')
        return
      }
      const now = Date.now()
      const end = endTime * 1000
      const diff = end - now
      if (diff <= 0) {
        setTimeLeft('Round ended')
        return
      }
      const hours = Math.floor(diff / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((diff % (1000 * 60)) / 1000)
      setTimeLeft(`${hours}h ${minutes}m ${seconds}s`)
    }
    updateTimer()
    const interval = setInterval(updateTimer, 1000)
    return () => clearInterval(interval)
  }, [endTime])

  const getStateLabel = () => {
    switch (state) {
      case 0: return timeLeft || 'Round ended'
      case 1: return 'Drawing...'
      case 2: return 'Completed'
      case 3: return 'Cancelled'
      default: return ''
    }
  }

  const formatPool = (value: string) => {
    const num = parseFloat(value)
    if (isNaN(num)) return '$0.00'
    return `$${num.toFixed(2)}`
  }

  return (
    <div className="card">
      <h2 className="text-sm font-medium text-telegram-hint mb-3">Current Round</h2>
      <div className="text-center mb-4">
        <div className="text-4xl font-bold text-gold-500 prize-glow">{formatPool(pool)}</div>
        <div className="text-sm text-telegram-hint mt-1">Prize Pool</div>
      </div>
      <div className="text-center mb-4">
        <div className="text-lg font-medium text-telegram-text countdown">{timeLeft || '—'}</div>
        <div className="text-xs text-telegram-hint">Ends in</div>
      </div>
      <div className="flex items-center justify-between text-sm">
        <a
          href="https://hybridlotto.win"
          target="_blank"
          rel="noopener noreferrer"
          className="text-telegram-link hover:underline"
        >
          🌐 Open Web Version
        </a>
        <span className={`font-medium ${state === 0 ? 'text-green-400' : state === 1 ? 'text-yellow-400' : state === 2 ? 'text-gold-500' : 'text-red-400'}`}>
          {getStateLabel()}
        </span>
      </div>
    </div>
  )
}
